var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ArvandUserLoanPaymentPrintHtml',{attrs:{"userLoanPayment":_vm.userLoanPayment,"member":_vm.member,"area":_vm.area},on:{"ready":function($event){return _vm.$emit('ready')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }